// @ts-nocheck
/* eslint-disable */

  /**
  * Do not change! File was auto generate. 
  *
  */
  
import React from 'react';

import { ReactComponent as ArrowRightAltComponent} from './ArrowRightAlt.svg';

import Icon, { TIconProps } from '../Icon';

export const IconArrowRightAlt = React.forwardRef<any, TIconProps>((props, ref) => (
  <Icon
    ref={ref}
    {...props}
  >
    <ArrowRightAltComponent/>
  </Icon>
));
